import { c as _c } from "react/compiler-runtime";
import type { CSSProperties, ReactNode } from 'react';
import * as motion from 'motion/react-client';
type EnterAnimationProps = {
  children: ReactNode;
  className?: string;
};
export function EnterAnimation(t0) {
  const $ = _c(6);
  const {
    children,
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: "1rem"
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.3,
      y: {
        type: "spring",
        visualDuration: 0.4,
        bounce: 0
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== className) {
    t4 = <motion.div initial={t1} animate={t2} transition={t3} className={className}>{children}</motion.div>;
    $[3] = children;
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
type StickyCenterMotionProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};
export function StickyCenterMotion(t0) {
  const $ = _c(7);
  const {
    children,
    className,
    style
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      scale: 0.98
    };
    t2 = {
      opacity: 1,
      scale: 1
    };
    t3 = {
      opacity: {
        duration: 0.2
      },
      scale: {
        duration: 0.2
      }
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== className || $[5] !== style) {
    t4 = <motion.div initial={t1} animate={t2} transition={t3} className={className} style={style}>{children}</motion.div>;
    $[3] = children;
    $[4] = className;
    $[5] = style;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}